import axios from "axios";
import { api, apiTranslate, apiIdentity } from "./paths";

export const contentTypes = {
  ajax: "application/json",
  form: "application/x-www-form-urlencoded; charset=UTF-8",
  jsonPatch: "application/json-patch+json",
  file: false
};

export const methods = {
  get: "GET",
  post: "POST",
  put: "PUT",
  delete: "DELETE"
};

export const axiosLanguage = function(language) {
  requestJSON.defaults.headers.common["Accept-Language"] = language
    ? language
    : localStorage.getItem("language");
  requestTranslate.defaults.headers.common["Accept-Language"] = language
    ? language
    : localStorage.getItem("language");
};

export const responseTypes = {
  arrayBuffer: "arraybuffer"
};

export const requestIdentity = axios.create({
  baseURL: apiIdentity,
  headers: {
    "Content-Type": "application/json, application/json-patch+json",
    Accept: "application/json, text/plain, */*"
  },
  transformRequest: [
    function(data) {
      return JSON.stringify(data);
    }
  ]
});

export const requestJSON = axios.create({
  baseURL: api,
  headers: {
    "Content-Type": "application/json; charset=UTF-8",
    Accept: "application/json, text/plain, */*"
  }
});

export const requestBO = axios.create({
  baseURL: api,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json; charset=UTF-8",
    Accept: "application/json, text/plain, */*"
  }
});

export const requestFile = axios.create({
  baseURL: api,
  withCredentials: true,
  headers: {
    Accept: "application/json, text/plain, */*"
  }
});
export const requestJSONSca = axios.create({
  baseURL: api,
  headers: {
    "Content-Type": "application/json; charset=UTF-8",
    Accept: "application/json, text/plain, */*"
  }
});

export const requestTranslate = axios.create({
  baseURL: apiTranslate,
  headers: {
    "Content-Type": "application/json; charset=UTF-8",
    Accept: "application/json, text/plain, */*"
  }
});

export const requestWithToken = axios.create({
  baseURL: api,
  headers: {
    "Content-Type": "application/json; charset=UTF-8",
    Accept: "application/json, text/plain, */*"
  }
});
